import { ApplicationConfig, CSP_NONCE, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { HttpClientModule, HttpClientXsrfModule, provideHttpClient, withInterceptors, withXsrfConfiguration,
  withFetch
 } from '@angular/common/http';
import { casiXsrfInterceptor } from './interceptors/casi-xsrf.interceptor';
// import { bearerInterceptor } from './interceptors/bearer.interceptor';
import { cookieInterceptor } from './interceptors/cookie.interceptor';
import { CookieService } from 'ngx-cookie-service';
import { bearerRefreshInterceptor } from './interceptors/bearer-refresh.interceptor';
import { cookieHeaderName, csrfTokenName } from './common/constants.lib';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { loadingInterceptor } from './interceptors/loading.interceptor';
import { spinnerInterceptor } from './interceptors/spinner.interceptor';
// import { httpInterceptorProviders } from './interceptors/http.interceptor';
// import { loadingInterceptor } from './interceptors/loading.interceptor';
// import { BrowserModule } from '@angular/platform-browser';
// import { AppRoutingModule } from '../../../db-manager-ng/src/app/app-routing.module';
// import { LoadingIndicatorService } from './shared/loading-indicator.service';

export const appConfig: ApplicationConfig = {
  providers: [
    // httpInterceptorProviders,
    // importProvidersFrom(HttpClientModule),
    // importProvidersFrom(HttpClientXsrfModule.withOptions({
    //   cookieName: 'X-CSRF-TOKEN',
    //   headerName: 'X-CSRF-TOKEN'
    // })),
    provideRouter(routes, withComponentInputBinding()),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })),
    provideHttpClient(
      withFetch(),
      withXsrfConfiguration({
        cookieName: cookieHeaderName, // 'X-CSRF-TOKEN',
        headerName: csrfTokenName // 'X-CSRF-TOKEN'
      }),
      // withInterceptors([casiXsrfInterceptor, bearerInterceptor, cookieInterceptor])
      // withInterceptors([httpInterceptor])
      // withInterceptors([bearerRefreshInterceptor, bearerInterceptor, cookieInterceptor])
      // withInterceptors([bearerInterceptor, cookieInterceptor])
      withInterceptors([casiXsrfInterceptor, bearerRefreshInterceptor, cookieInterceptor, spinnerInterceptor])
      // withInterceptors([bearerRefreshInterceptor, cookieInterceptor])
    ),
    provideToastr({
      timeOut: 2000,
      positionClass: 'toast-top-center',
      preventDuplicates: true
    }),
    CookieService,
    provideAnimationsAsync(),
    // importProvidersFrom(
    //   BrowserModule,
    //   AppRoutingModule,
    //   RouterModule,
    //   LoadingIndicatorService
    // ), {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: loadingInterceptor,
    //   multi: true
    // }
    // {
    //   provide: ICON_SETTINGS,
    //   useValue: {
    //     type: "font"
    //   }
    // }
  ]
};
